const local = 0
const baseURL = local ? "http://127.0.0.1:5000/" : "https://tourhubbackend.onrender.com/"

export const fetchCountries = async () => {
    try {
      const response = await fetch(baseURL + "countries", {
          method: 'GET',
          });
      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      console.log("Response from backend:", result);
      return result
    } catch (error) {
        console.error("Error fetching data:", error);
    } 
  }

export const fetchCities = async () => {
    try {
      const response = await fetch(baseURL + "cities", {
        method: 'GET',
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const result = await response.json();
      console.log("Response from backend:", result);
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      return null;
    }
};

export const fetchPoisByCities = async (cities) => {
    const city_ids = cities.map(city => city.value);
  
    try {
      const response = await fetch(baseURL + "pois/by_cities", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ city_ids }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const result = await response.json();

      console.log("POIs grouped by city:", result);
      return result;
    } catch (error) {
      console.error("Error fetching POIs:", error);
      return null;
    }
};
  
export const fetchPoisByCity = async (city_id) => {

  try {
    const response = await fetch(baseURL + "pois/by_city/" + city_id.toString(), {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();

    console.log("POIs for city:" , result);
    return result;
  } catch (error) {
    console.error("Error fetching POIs:", error);
    return null;
  }
};

export const createUser = async (data, full) => {
    var link = 'users/survey'
    if (full){
      link = 'users/trip' 
    }
    try {
      const response = await fetch(baseURL + link, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
      });

      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log("id2:", result)
      return result
    } catch (error) {
        console.error("Error submitting data:", error);
    }
    console.log("noooo")
    return 0
};

export const submitSurveyData = async (userId, poiRatings) => {
  var link = 'survey'
  try {
    console.log("Request body: ", JSON.stringify({"user_id": userId, "poi_ratings": poiRatings}))
    const response = await fetch(baseURL + link, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"user_id": userId, "poi_ratings": poiRatings}),
    });

    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    return result
  } catch (error) {
      console.error("Error submitting data:", error);
  }
  return 0
};